import { useEffect, useState } from "react";

export type WindowSize = {
    width: number | undefined;
    height: number | undefined;
}



export function useWindowResize(action?: () => void){
    const [windowSize, setWindowSize] = useState<WindowSize>({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
          // Set window width/height to state
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
          if (action)  action();
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
      }, [action]); // Empty array ensures that effect is only run on mount --> action passed in should be memoized to avoid re-renders
      return windowSize;
}